<template>
  <v-container fluid>
    <div class="d-flex align-center">
      <span class="text-h6">C-VIWER</span>
      <v-spacer/>
      <v-img 
        src="@/assets/images/logo.png"
        max-height="40px"
        max-width="120px"
        contain
      />
    </div>

    <RadarChart 
      ref="chart" 
      :height="320"
    />

    <div 
      v-if="summary"
      class="d-flex flex-column"
    >
      <div class="d-flex align-center w-100 ga-1">
        <div 
          class="text-h6 font-weight-bold d-flex align-center justify-center"
          style="width: 120px;"
        >
          歩行年齢
        </div>

        <div :style="summayBarLabelStyle">50歳以下</div>
        <div 
          class="w-0 flex-grow-1 rounded-xl"
          style="
            height: 16px;
            overflow: hidden;
            background: #f1279344;
            position: relative; 
          "
        >
          <div
            :style="{
              width: '8px',
              height: '100%',
              position: 'absolute',
              background: 'red',
              top: 0,
              left: `calc(${100*(summary.gaitAge - 50)/(90 - 50)}% - 4px)`,
            }"
          >
          </div>
        </div>
        <div :style="summayBarLabelStyle">90歳以上</div>
      </div>
      <div class="d-flex align-center ga-1 w-100">
        <div 
          class="text-h6 font-weight-bold d-flex align-center justify-center"
          style="width: 120px;"
        >
          転倒リスク
        </div>
        <div :style="summayBarLabelStyle">小</div>
        <div 
          class="w-0 flex-grow-1 rounded-xl"
          style="
            height: 16px;
            overflow: hidden;
            background: #f1279344;
            position: relative;
          "
        >
          <div
            :style="{
              width: '8px',
              height: '100%',
              position: 'absolute',
              background: 'red',
              top: 0,
              left: `calc(${100*summary.fallRisk}% - 4px)`,
            }"
          >
          </div>
        </div>
        <div :style="summayBarLabelStyle">大</div>
      </div>
    </div>

    
    <div class="d-flex align-center justify-center mt-5 ga-3">
      <v-spacer/>

      <Dialog
        :applicable="false"
        ref="historyDialog"
      >
        履歴選択
        <template #title>
          歩行履歴
        </template>
        <template #cancel>閉じる</template>
        <template #contents>
          <v-list dense>
            <template v-for="s, index in summaries">
              <v-list-item
                :key="s.createdTime"
                @click="selectHistory(s)"
              >
                {{ s.createdTime }}
              </v-list-item>
              <v-divider
                v-if="index < summaries.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </template>
      </Dialog>

      <v-spacer/>
    </div>
  </v-container>
</template>

<script>
import db from "@js/storages/IndexedDB.js";
import RadarChart from '@components/parts/charts/RadarChart.vue'
import Dialog from "@components/parts/dialogs/Dialog.vue";

export default {
  components: {
    RadarChart,
    Dialog,
  },
  data: function(){
    return {
      summaries: false,
      summary: null,
      
      summayBarLabelStyle: {
        'max-width': '32px',
        'min-width': '32px',
        'white-space': 'break-spaces',
        'font-size': '12px',
        'line-height': 1,
        'text-align': 'center',
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center',
      },

      features: [
        {
          key: "basicSkill",
          label: "基礎力"
        },
        {
          key: "stability",
          label: "安定性"
        },
        {
          key: "symmetry",
          label: "対称性"
        },
        {
          key: "beauty",
          label: "美しさ"
        },
        {
          key: "drivingForce",
          label: "駆動力"
        },
      ]
    }
  },
  computed: {
  },
  watch: {
    summary: function(newVal){
      if(!newVal){
        return;
      }

      this.$refs.chart.dataCollection.datasets = [
        {
          label: '歩行の健康診断',
          data: this.features.map(f => newVal[f.key]),
          backgroundColor: "#92657d66",
          borderColor: "#92657dff",
          borderWidth: 2,
        }
      ];
      this.$refs.chart.updateChart();
    },
  },
  mounted: async function(){
    this.summaries = await db.getSummaries();
    if(!this.$route.query.result){
      return;
    }

    this.summary = JSON.parse(atob(this.$route.query.result));
    this.$refs.chart.dataCollection.labels = this.features.map(f => f.label);
    if(!this.summaries.some(s => s.createdTime == this.summary.createdTime)){
      db.addSummary({
        createdTime: this.summary.createdTime,
        detail: JSON.stringify(this.summary),
      })
    }
  },
  methods: {
    selectHistory: function(summary){
      this.summary = JSON.parse(summary.detail);
      this.$refs.historyDialog.close();
    },
  }
}
</script>